import { lazy } from "react";

const UsuariosLayout = lazy(() =>
      import("../../empresa/UsuarioLayout.jsx")
);

const UsuariosList = lazy(() =>
      import("../../empresa/usuarios/UsuariosList.jsx")
);

const UsuarioForm = lazy(() =>
      import("../../empresa/usuarios/UsuarioForm.jsx")
);

const PerfilesLayout = lazy(() =>
      import("../../empresa/perfiles/PerfilesLayout.jsx")
);

const FuncionesLayout = lazy(() =>
      import("../../empresa/funciones/FuncionesLayout.jsx")
);

const sistemaRoutes = [
      {
            path: "sistema/usuarios",
            element: <UsuariosLayout />,
            children: [
                  {
                        path: "",
                        element: <UsuariosList />,
                  },
                  {
                        path: "nuevo",
                        element: <UsuarioForm />,
                  },
                  {
                        path: "editar/:token",
                        element: <UsuarioForm />,
                  },
            ],
      },
      {
            path: "sistema/perfiles",
            element: <PerfilesLayout />,
      },
      {
            path: "sistema/funciones",
            element: <FuncionesLayout />,
      },
];

export default sistemaRoutes;